// extracted by mini-css-extract-plugin
module.exports = {"page":"Pi","account":"Qi","pdp":"Ri","cart":"Si","brand":"Ti","cartModal":"Ui","checkout":"Vi"};